<template>
    <I18nT
        v-bind:keypath="message.resourceKey"
        scope="global"
    >
        <template #highlightedText>
            <span class="highlight">
                {{ message.highlightText }}
            </span>
        </template>
    </I18nT>
</template>

<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import { i18n } from '@/libraries/i18n';
    import { useParlayBetSlipStore } from '@/stores/betSlip/parlayBetSlipStore';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';

    defineOptions({
        name: 'MpSubBetCountInsufficientMessage',
    });

    interface IProps {
        missingCount?: number | null;
        isTwoSubBetMessage?: boolean | null;
    }

    const props = withDefaults(defineProps<IProps>(), {
        missingCount: null,
        isTwoSubBetMessage: null,
    });

    const { isSupportMpTwoSubBets } = useFeatureToggleStore();
    const { countOfAddMore, subBets } = storeToRefs(useParlayBetSlipStore());

    const isLegacyStoreTwoSubBetMessage = computed(() => (
        subBets.value.length === 1
        && isSupportMpTwoSubBets(subBets.value[0].leagueId)
    ));
    const resolvedMissingCount = computed(() => props.missingCount ?? countOfAddMore.value);
    const resolvedIsTwoSubBetMessage = computed(() => (
        props.isTwoSubBetMessage ?? isLegacyStoreTwoSubBetMessage.value
    ));

    const message = computed(() => {
        if (resolvedIsTwoSubBetMessage.value) {
            return {
                resourceKey: 'bet_slip_message_mp_two_sub_bets',
                highlightText: i18n.t('bet_slip_message_mp_two_sub_bets_highlightedText'),
            };
        }
        return {
            resourceKey: 'betSlip_addMoreMixParlay',
            highlightText: i18n.t('betSlip_addMoreMixParlayHighlightedText', {
                count: resolvedMissingCount.value,
            }),
        };
    });
</script>

<style lang="scss" scoped>
    .highlight {
        font-weight: bold;
    }
</style>
